export const SESSIONS_REQUEST = 'SESSIONS_REQUEST';
export const SESSIONS_SUCCESS = 'SESSIONS_SUCCESS';

export const UPDATE_SESSION_REQUEST = 'SESSIONS_UPDATE_SESSION_REQUEST';
export const UPDATE_SESSION_SUCCESS = 'SESSIONS_UPDATE_SESSION_SUCCESS';

export const BULK_DELETE_SESSIONS_REQUEST = 'SESSIONS_BULK_DELETE_SESSIONS_REQUEST';
export const BULK_DELETE_SESSIONS_SUCCESS = 'SESSIONS_BULK_DELETE_SESSIONS_SUCCESS';

export const COURSES_SUCCESS = 'SESSIONS_COURSES_SUCCESS';

export const COURSE_SCENARIOS_SUCCESS = 'SESSIONS_COURSE_SCENARIOS_SUCCESS';

export const LOCATIONS_SUCCESS = 'SESSIONS_LOCATIONS_SUCCESS';

export const ORGANIZATIONS_SUCCESS = 'SESSIONS_ORGANIZATIONS_SUCCESS';

export const SCENARIOS_SUCCESS = 'SESSIONS_SCENARIOS_SUCCESS';

export const SIMULATORS_SUCCESS = 'SESSIONS_SIMULATORS_SUCCESS';

export const USERS_SUCCESS = 'SESSIONS_USERS_SUCCESS';

export const DISPOSE_SESSIONS_STORE = 'DISPOSE_SESSIONS_STORE';

export const Roots = {
    sessions: 'sessions',
    live: 'live',
    vera: 'vera',
} as const;

export type Root = (typeof Roots)[keyof typeof Roots];
